module.exports = __webpack_public_path__ + "static/media/instagram-stories-are-everywhere.57a6dffe.jpg";